import React from "react";
import PropTypes from "prop-types";
import { Form } from "react-final-form";
import { Button, Grid } from "@mui/material";
import { withTranslation } from "react-i18next";
class FormWizard extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
  };
  static Page = ({ children, setactiveStep }) => children;

  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      values: props?.initialValues || {},
      isSubmitting: false,
    };
  }

  next = (values) =>
    this.setState((state) => ({
      page: Math.min(state.page + 1, this.props?.children.length - 1),
      values,
      isSubmitting: false,
    }));

  previous = () =>
    this.setState((state) => ({
      page: Math.max(state.page - 1, 0),
    }));

  componentDidUpdate(prevProps, prevState) {
    if (this.state.page !== prevState.page) {
      this.props?.setactiveStep(this.state.page);
    }
  }
  /**
   * NOTE: Both validate and handleSubmit switching are implemented
   * here because 🏁 Redux Final Form does not accept changes to those
   * functions once the form has been defined.
   */

  validate = (values) => {
    const activePage = React.Children.toArray(this.props?.children)[
      this.state.page
    ];
    return activePage.props?.validate ? activePage.props.validate(values) : {};
  };

  handleSubmit = (values) => {
    this.setState({ isSubmitting: true });
    const { children, onSubmit, onNextClickForm } = this.props;
    const { page } = this.state;
    const isLastPage = page === React.Children.count(children) - 1;
    if (isLastPage) {
      return onSubmit(values);
    } else {
      onNextClickForm(values).then(() => this.next(values));
    }
  };
  handleEditDetailsClick = () => {
    // Navigate to the first wizard page
    this.setState({
      page: 0,
    });
  };

  handleClearClick = (form) => {
    const emptyValues = Object.keys(this.state.values).reduce((acc, key) => {
      acc[key] = "";
      return acc;
    }, {});

    this.setState(
      {
        values: emptyValues,
      },
      () => {
        form.reset(emptyValues); // Ensure form is reset after state update
      }
    );
  };
  handleBankChange = (event, values, previousValues) => {
    const bankCode = values?.bankCode || "";
    this.setState((state) => ({
      values: {
        ...state.values,
        bankCode, // Update bankCode value based on selected bank
      },
    }));
  };
  render() {
    const { children, initVal, documentDetails, t } = this.props;
    const { page, values, isSubmitting } = this.state;
    const activePage = React.Children.toArray(children)[page];
    const isLastPage = page === React.Children.count(children) - 1;
    return (
      <Form
        initialValues={initVal}
        validate={this.validate}
        onSubmit={this.handleSubmit}
      >
        {({ handleSubmit, submitting, values, errors, form }) => (
          <form onSubmit={handleSubmit}>
            {/* {activePage} */}
            {React.cloneElement(activePage, { values })}
            <div className="button-group">
              {page > 0 && !isLastPage && (
                <Button type="button" onClick={this.previous}>
                  {/* « Précédent */}« {t("previous")}
                </Button>
              )}
              {page == 0 && (
                <Button
                  type="button"
                  variant="outlined"
                  onClick={() => this.handleClearClick(form)}
                >
                  {t("clear")}
                  {/* Effacer */}
                </Button>
              )}
              {isLastPage && (
                <Button
                  type="button"
                  variant="outlined"
                  onClick={this.handleEditDetailsClick}
                  disabled={isSubmitting}
                >
                  {/* Modifier les détails */}
                  {t("editDetails")}
                </Button>
              )}
              {!isLastPage && (
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  className="itemDetail"
                  disabled={
                    this.state.page == 1
                      ? documentDetails == 0 || isSubmitting
                      : submitting ||
                        Object.keys(errors).length > 0 ||
                        isSubmitting
                  }
                >
                  {t("saveNext")} »
                </Button>
              )}
              {isLastPage && (
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  className="itemDetail"
                  disabled={submitting || isSubmitting}
                >
                  {t("Submit")}
                </Button>
              )}
            </div>
          </form>
        )}
      </Form>
    );
  }
}

export default FormWizard;
